import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from './modules/indexRouter.js'// 主页路由
import PersonalPage from './modules/personalRouter.js'// 主页路由
import SuperviseRouter from './modules/superviseRouter.js' // 不存在或者无权限页面
import regulationTheSceneRouter from './modules/regulationTheSceneRouter.js' // 不存在或者无权限页面
import riskAversion from './modules/riskAversionRouter.js'
import caseRouter from './modules/caseRouter.js'
import mediationRouter from './modules/mediationRouter.js'
import stylistRouter from './modules/stylistRouter.js'
import DesignRouter from './modules/designRouter.js'
import LongRouter from './modules/longRouter.js'
import StrategyRouter from './modules/strategyRouter.js'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// console.log('1111111111111111111111111')

let routes = []
// 添加不同的路由模块
routes = routes.concat(
  IndexPage,
  PersonalPage,
  SuperviseRouter,
  regulationTheSceneRouter,
  riskAversion,
  caseRouter,
  mediationRouter,
  stylistRouter,
  DesignRouter,
  LongRouter,
  StrategyRouter
)
export default new Router({
  mode: "history",
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js